
import { DiaryEntry } from "@/utils/diary/types";

interface EntryTagsProps {
  activities: string[];
  milestones: string[];
}

const EntryTags = ({ activities, milestones }: EntryTagsProps) => {
  return (
    <div className="flex gap-1.5 flex-wrap">
      {activities.map((activity, i) => (
        <span key={i} className="px-2 py-1 text-xs rounded-md bg-secondary text-secondary-foreground">
          {activity}
        </span>
      ))}
      {milestones.map((milestone, i) => (
        <span key={`m-${i}`} className="px-2 py-1 text-xs rounded-md bg-primary/15 text-primary">
          {milestone}
        </span>
      ))}
    </div>
  );
};

export default EntryTags;
